function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
import { CxmRulesClientHeader } from '../types/cxm-rules-client-header';
/**
 * Gets the [[HttpRequestConfiguration]] for a particular API request, including request-specific headers.
 *
 * Merges the provided [[CxmRulesClientConfig]] `authToken` and [[HttpRequestConfiguration]].
 */ export const getRequestConfig = async (config, requestConfig)=>{
    const headers = new Headers(requestConfig == null ? void 0 : requestConfig.headers);
    const authToken = await config.authTokenProvider();
    headers.append(CxmRulesClientHeader.Authorization, `Bearer ${authToken}`);
    return _extends({}, requestConfig, {
        headers
    });
};
